import React, { useState } from 'react'

import { Box, Flex, Icon, InlineButton, Link, Text } from '@driftt/dds'
import { faArrowPointer } from '@driftt/dds.icons/light/faArrowPointer';

import { pluralize } from 'utils/formatStrings'
import { stripParams } from 'utils/urlUtils';


interface ContentRecommentationContentProps {
  pages: { url?: string; title?: string }[]
  trackAction: (action: string, additionalData?: any) => void
}

export const ContentRecommentationContent = ({ pages, trackAction }: ContentRecommentationContentProps) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Flex direction="column" css={{ paddingTop: '16px' }} gap={0}>
      <Flex alignItems='center' css={{ paddingBottom: '4px' }}>
        <Icon size="large" icon={faArrowPointer} />
        {`Clicked ${pages.length} ${pluralize('recommendation', pages.length)}`}
      </Flex>
      {pages.slice(0, expanded ? pages.length : 2).map((page, index) => (
        <Box key={index} css={{ 
            border: '1px solid var(--drift-dds-colors-gray3)', 
            borderRadius: '4px', 
            padding: '10px 12px',
            marginTop: '4px',
            width: '100%'
        }}>
            <Text css={{ color: 'black' }}>{page.title}</Text>
            <Link
            href={page.url}
            target="_blank"
            truncate
            css={{ color: '$gray8' }}>
            {stripParams(page.url)}
            </Link>
        </Box>
      ))}
      {pages.length > 2 && !expanded && (
        <InlineButton
          onClick={() => {
            setExpanded(true)
            trackAction('Expand page views list')
          }}
          css={{ fontWeight: 400, padding: 0, marginTop: '4px', color: '$blue9' }}>{`+${pages.length -
          2} more`}</InlineButton>
      )}
    </Flex>
  )
}
